import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    header: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        marginBottom: 32,
    },
    headerTitle: {
        fontSize: 22,
        fontWeight: 700,
    },
    headerSubtitle: {
        maxWidth: 560,
        marginTop: 8,
        color: theme.palette.text.secondary,
    },
    footerNote: {
        display: 'block',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginTop: 24,
    },
    // Two layouts, picked via the `layout` prop:
    cards: ({ cardWidth, cardGap, layout }) => (layout === 'responsive' ? {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
        gap: 24,
        alignItems: 'stretch',
    } : {
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fit, ${cardWidth}px)`,
        justifyContent: 'center',
        alignItems: 'stretch',
        gap: cardGap,
        paddingTop: 16,
    }),
}));
